
import React from "react";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const BrowsingHistory = () => {
  const navigate = useNavigate();
  
  return (
    <div className="text-center py-16">
      <Clock className="h-12 w-12 mx-auto text-muted-foreground" />
      <h3 className="text-xl font-medium mt-4">No browsing history yet</h3>
      <p className="text-muted-foreground mt-2">
        Your recently viewed careers, mentors, and resources
        will appear here for easy access.
      </p>
      <Button 
        variant="outline" 
        className="mt-6"
        onClick={() => navigate('/explore')}
      >
        Start Exploring
      </Button>
    </div>
  );
};

export default BrowsingHistory;
